/* eslint camelcase: "off" */

import cookie from 'amkit3-modules/utils/cookie'
import { sendToURL } from 'amkit3-modules/utils/ajax'
import { STATISTIC_YA } from 'amkit3-modules/utils/services/urls'
import { getOneTime } from 'amkit3-modules/utils/services/statistic/onetime'

let pro = 'huyasp' + (process.env.NODE_ENV === 'development' || process.env.TEST ? '_test' : '')
let pas = cookie.get('username')

if (global.YA) {
  if (!global.ya) {
    global.ya = new global.YA(pro, pas, {
      pageType: 'ROOT',
    })
  }
}

let yaStatistic = (
  eid,
  eid_desc,
  dur,
  pro,
  session_id,
  dty,
  mid,
  yyuid,
  pas,
  cha,
  hasvideo,
  watchvideo,
  vid,
  curl,
  isflash,
  furl,
  ref,
  lla,
  os,
  sre,
  platform,
  ati,
  props,
) => {
  if (global.ya) {
    mid = global.YA.mid.get()
    session_id = global.YA.session_id.get()
  }
  let prop = props || JSON.stringify({ onetime: getOneTime(vid) })
  console.log('props', prop, eid)
  sendToURL(STATISTIC_YA, {
    rid: 'ods_action_log',
    sdver: 1,
    cutc: +new Date(),
    eid,
    eid_desc,
    dur,
    pro,
    session_id,
    dty,
    mid,
    yyuid,
    pas,
    cha,
    hasvideo,
    watchvideo,
    vid,
    curl,
    isflash,
    furl,
    ref,
    lla,
    os,
    sre,
    platform,
    ati,
    prop,
  })
}

export const hysp_videoplay_vv_web = (...args) => {
  yaStatistic.apply(null, ['hysp/videoplay/vv/web', '视频/视频播放/浏览次数/web'].concat(args))
}

export const hysp_videoplay_PlayTimeLength_web = (...args) => {
  yaStatistic.apply(
    null,
    ['hysp/videoplay/PlayTimeLength/web', '视频/视频播放/观看时长/web'].concat(args),
  )
}

export const hysp_videoplay_bullet_click_web = (...args) => {
  yaStatistic.apply(
    null,
    ['hysp/videoplay/bullet/click/web', '视频/播放页/弹幕发送/点击'].concat(args),
  )
}

export const hysp_videoplay_bulletoff_click_web = (...args) => {
  yaStatistic.apply(
    null,
    ['hysp/videoplay/bulletoff/click/web', '视频/播放页/弹幕关闭/点击'].concat(args),
  )
}

export const hysp_videoplay_errortimes = (...args) => {
  yaStatistic.apply(null, ['hysp/videoplay/errortimes', '视频/视频播放/报错次数'].concat(args))
}

export const hysp_videoplay_badtimes = (...args) => {
  yaStatistic.apply(null, ['hysp/videoplay/badtimes', '视频/视频播放/卡顿次数'].concat(args))
}

export const hysp_videoplay_bullet_live_click_web = (...args) => {
  yaStatistic.apply(null, ['usr/click/checkbox', '用户/点击/现场弹幕复选框'].concat(args))
}

export default {
  hysp_videoplay_vv_web,
  hysp_videoplay_PlayTimeLength_web,
  hysp_videoplay_bullet_click_web,
  hysp_videoplay_bulletoff_click_web,
  hysp_videoplay_errortimes,
  hysp_videoplay_badtimes,
  hysp_videoplay_bullet_live_click_web,
}
